export default "__VITE_ASSET__CKT2sNZ4__"